import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
/**
 * Dropdown bound to `/api/yield-curves/keys`. Use it to pick a curve by
 * its key (e.g. "USD_OIS") for any field whose value is a curve
 * reference — assumption values, scenario overrides, etc.
 */
export function YieldCurvePicker({ name, value, onChange, required, disabled, className, currency, allowBlank, }) {
    const q = useQuery({
        queryKey: ["yield-curve-keys"],
        queryFn: () => api.get("/yield-curves/keys"),
        staleTime: 60_000,
    });
    const filtered = (q.data ?? []).filter((c) => !currency || c.currency_code.toUpperCase() === currency.toUpperCase());
    return (_jsxs("select", { name: name, required: required, disabled: disabled || q.isLoading, value: value ?? "", onChange: (e) => onChange?.(e.target.value), className: className ?? "input font-mono", children: [(allowBlank || !value) && _jsx("option", { value: "", children: "\u2014 select a curve \u2014" }), filtered.map((c) => (_jsxs("option", { value: c.key, children: [c.key, " \u00B7 ", c.currency_code, " \u00B7 ", c.name, " (", c.snapshot_count, " snapshots)"] }, c.key))), value && !filtered.find((c) => c.key === value) && (_jsxs("option", { value: value, children: [value, " (not in dictionary)"] }))] }));
}
